import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';

const ResourceDetails = ({ details, onDeallocate }) => {
  return (
    <>
        <Typography color="primary" variant="body2" sx={{ fontWeight: 'bold', paddingBottom: '7px' }}>
            Allocated Resource
        </Typography>
        <Grid container sx={{ mb: '5px' }} spacing={2}>
            {details.map((detail, index) => (
                <Grid item xs key={index}>
                <Box>
                    <Box color="primary" variant="body1" sx={{ color: 'primary' }}>
                        {detail.label} :
                    </Box>
                    <Typography color="primary" variant="body2" sx={{ fontWeight: 'bold' }}>
                        {detail.value}
                    </Typography>
                </Box>
                </Grid>
            ))}
            <ResourceActions onDeallocate={onDeallocate} />
        </Grid>
    </>
  );
};

const ResourceActions = ({ onDeallocate }) => {
    return (
        <Grid item xs="auto">
        <Button variant="contained" size="small" onClick={onDeallocate}>
            Deallocate
        </Button>
        </Grid>
    );
};

export default ResourceDetails;
